import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { TenantConfigComponent } from './detail/tenant-config/tenant-config.component';

@Component({
  selector: 'app-tenant-config-page',
  standalone: true,
  imports: [TenantConfigComponent, TestIdDirective],
  template: ` <tenant-config [tenantId]="tenantId" [standalonePage]="true" testId="tenant-config-page" /> `
})
export class TenantConfigPageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '';
}
